import { Button } from '@/components/ui';

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  onOpenTerms: () => void;
  disabled?: boolean;
}

export default function TermsCheckbox({
  checked,
  onChange,
  onOpenTerms,
  disabled = false,
}: TermsCheckboxProps) {
  return (
    <div className="flex items-start gap-3 mt-4 text-left select-none">
      <label className="group flex items-baseline gap-3 cursor-pointer group">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className="peer sr-only"
          aria-label="Accept terms and conditions"
        />
        <div
          aria-hidden="true"
          className={`peer-focus-visible:ring-2 peer-focus-visible:ring-[--state-brand-active] group h-[22px] aspect-square flex items-center justify-center transition-all duration-200 border-2 rounded-[--radi-4] bg-[#333333] mt-0.5 outline-none focus-visible:ring-2 focus-visible:ring-[--state-brand-active] focus-visible:ring-offset-2 focus-visible:ring-offset-[#231F1F] ${
            checked
              ? 'border-[--state-brand-active]'
              : 'border-[--base-border] group-hover:border-[--state-brand-active]'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div
            className={`h-full w-full rounded-[6px] flex items-center justify-center group-hover:bg-[--state-brand-active] border border-[--base-border] transition-opacity duration-200 bg-[--state-brand-active] ${
              checked ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <i className="ri-check-line text-[--text-light-primary] font-bold group-hover:opacity-100" />
          </div>
        </div>
        <span className="flex-1 text-nowrap flex gap-[6px] items-baseline text-sm text-[--text-dark-secondary]">
          Acepto los{' '}
          <Button
            variant="link"
            size="sm"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onOpenTerms();
            }}
            className="h-fit p-0 !w-auto"
          >
            Términos y Condiciones
          </Button>
        </span>
      </label>
    </div>
  );
}
